import React, { useState } from 'react';
import {
  Box,
  Typography,
  TextField,
  Button,
  Alert,
  CircularProgress,
} from '@mui/material';

const Contact = () => {
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus('');
    const formData = new FormData(e.target);

    try {
      const response = await fetch('https://formspree.io/f/mpwyvwjl', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' },
      });

      if (response.ok) {
        setStatus('success');
        e.target.reset();
      } else {
        setStatus('error');
      }
    } catch (error) {
      console.error(error);
      setStatus('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        minHeight: '100vh',
        p: 4,
        backdropFilter: 'blur(5px)',
      }}
    >
      <Typography variant="h3" color="primary" gutterBottom>
        Contact Us
      </Typography>

      <Typography variant="body1" color="text.secondary" mb={3}>
        Have a question or need a quote? Get in touch with our team below.
      </Typography>

      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          maxWidth: 500,
        }}
      >
        <TextField
          name="name"
          label="Name"
          variant="outlined"
          fullWidth
          required
        />
        <TextField
          name="email"
          label="Email"
          type="email"
          variant="outlined"
          fullWidth
          required
        />
        <TextField
          name="message"
          label="Message"
          variant="outlined"
          multiline
          rows={4}
          fullWidth
          required
        />

        <Button
          variant="contained"
          color="primary"
          type="submit"
          disabled={loading}
          sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
        >
          {loading ? (
            <>
              <CircularProgress size={20} color="inherit" />
              Sending...
            </>
          ) : (
            'Send Message'
          )}
        </Button>
      </Box>

      {status === 'success' && (
        <Alert severity="success" sx={{ mt: 2 }}>
          ✅ Message sent! We’ll get back to you soon.
        </Alert>
      )}
      {status === 'error' && (
        <Alert severity="error" sx={{ mt: 2 }}>
          ❌ Something went wrong — please try again.
        </Alert>
      )}
    </Box>
  );
};

export default Contact;
